/**
 * Platform Admin → Organizations: every customer organization, searchable; each opens its own detail page.
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import TenantManager from '@/components/admin/TenantManager';
import LoadingSpinner from '@/components/common/LoadingSpinner';
import { createTenant, getTenants } from '@/api/tenants';
import { apiError } from '@/utils/apiError';

export default function PlatformOrganizationsPage() {
  const navigate = useNavigate();
  const cache = useQueryClient();
  const [search, setSearch] = useState('');
  const tenants = useQuery({ queryKey: ['tenants'], queryFn: getTenants });
  const create = useMutation({ mutationFn: createTenant, onSuccess: () => cache.invalidateQueries({ queryKey: ['tenants'] }) });
  if (tenants.isLoading) return <LoadingSpinner label="Loading organizations..." />;
  const query = search.trim().toLowerCase();
  const shown = (tenants.data ?? []).filter((t) => !query || t.name.toLowerCase().includes(query) || t.slug.toLowerCase().includes(query));
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Organizations</h1>
        <p className="mt-1 text-sm text-gray-600">Customer organizations on the platform. Select one to see its plan, status and usage.</p>
      </div>
      {(tenants.error || create.error) && <p role="alert" className="rounded bg-red-50 p-3 text-red-700">{apiError(tenants.error || create.error)}</p>}
      <input type="search" aria-label="Search organizations" placeholder="Search by name or code…" className="input-field max-w-sm" value={search} onChange={(e) => setSearch(e.target.value)} />
      <TenantManager tenants={shown} onCreateTenant={(payload) => create.mutate(payload)} isCreating={create.isPending} onRowClick={(tenant) => navigate(`/platform/organizations/${tenant.id}`)} />
    </div>
  );
}
